import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/empty-table-cell.hbs';


    var EmptyTableRowView = Marionette.View.extend({
        template: Handlebars.compile(template),
        tagName: 'tr',
        templateContext: function() {
            return {
                num_cols: this.options.num_cols || 1,
                message: this.options.message || 'None'
            };
        }
    });

    export default EmptyTableRowView;

